module.exports = __webpack_public_path__ + "static/media/events-icon.ab8212ae.svg";